var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#3058A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99718 15.3157C5.51081 15.3157 2.68425 12.4891 2.68425 9.00272C2.68425 5.51635 5.51081 2.68979 8.99718 2.68979C12.4836 2.68979 15.3101 5.51635 15.3101 9.00272C15.3101 12.4891 12.4836 15.3157 8.99718 15.3157ZM8.99718 2.2876C5.29425 2.2876 2.28206 5.29978 2.28206 9.00272C2.28206 12.7057 5.29425 15.7178 8.99718 15.7178C12.7001 15.7178 15.7123 12.7057 15.7123 9.00272C15.7123 5.29978 12.7001 2.2876 8.99718 2.2876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3619 11.4047L11.0115 12.9229L10.9271 13.2902H10.5502L8.61243 13.2891H8.60456C7.82774 13.2761 7.21799 13.0697 6.81806 12.7052C7.16343 13.3144 7.89693 13.6671 8.92068 13.6839H8.92856L10.8658 13.6851H11.2427L11.3276 13.3177L11.6781 11.7996L11.4047 11.2196L11.3619 11.4047ZM10.7527 4.89599L10.476 4.32056L10.4366 4.50056L10.1739 5.69699H10.5767L10.7527 4.89599ZM12.1517 6.28031L11.8029 7.75687L11.7163 8.12137H9.6165L9.08325 10.5559C9.072 10.6256 9.06524 10.6965 9.06524 10.7359C9.06524 10.7702 9.06918 10.7921 9.07256 10.8028C9.11264 10.8178 9.1552 10.8251 9.19799 10.8242H9.42749L9.93262 8.51681H12.0324L12.1185 8.15174L12.4672 6.67518L12.1961 6.09243L12.1511 6.28031H12.1517ZM6.94181 8.12137H5.47874L5.98274 8.51681H6.85574L6.94181 8.12137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24412 11.2982H9.19068C8.78343 11.2875 8.59106 11.0755 8.59106 10.7357C8.59106 10.6547 8.60456 10.5473 8.61806 10.4669L9.23568 7.64761H11.3417L11.6904 6.17104H9.58443L9.97368 4.39917H8.25581L7.86599 6.17104H6.00187L5.66662 7.64761H7.53074L6.80512 10.9635C6.76574 11.1244 6.75168 11.3123 6.75168 11.4062C6.75168 12.3524 7.49812 12.7967 8.61243 12.8153L10.5497 12.8159L10.9001 11.2982H9.24412Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpay);
export default __webpack_public_path__ + "static/media/tpay.58daca91134d3b579008f29ec49340ad.svg";
export { ForwardRef as ReactComponent };